import { MutationTree } from "vuex";
import i18n from "../i18n";
import GDPRStore from "@/GDPRStore";
import { Groups, IRootState, User } from "@iloq/shared";

const mutations: MutationTree<IRootState> = {
  setUser(state: IRootState, user: User): void {
    state.user = user;
    if (user) {
      if (user.languageCode === "en" && user.countryCode === "US") {
        i18n.locale = `${user.languageCode}-${user.countryCode}`;
      } else {
        i18n.locale = user.languageCode;
      }
    }
    // hide dialog if group or local storage consent exists
    if (user?.groups.includes(Groups.optionGdpr) || GDPRStore.loadGdprConsent()) {
      state.gdprDialog.active = false;
    } else {
      state.gdprDialog.active = true;
    }
  },
  setPartnerIdToUser(state: IRootState, partnerId: string): void {
    if (partnerId && state.user) {
      state.user = {
        ...state.user,
        hasPermissions: state.user.hasPermissions,
        partnerId,
      };
    }
  },
  hideGDPR(state: IRootState): void {
    state.gdprDialog.active = false;
  },
  showGeneralError(
    state: IRootState,
    data?: { dialogTitle?: string; dialogText?: string; error?: Error },
  ): void {
    state.generalError.isBlockedError = false;
    state.generalError.dialogTitle = data ? data.dialogTitle : undefined;
    state.generalError.dialogText = data ? data.dialogText : undefined;
    state.generalError.error = data ? data.error : undefined;
    state.generalError.active = true;
  },
  showBlockedActivityError(state: IRootState): void {
    state.generalError.isBlockedError = true;
    state.generalError.dialogTitle = undefined;
    state.generalError.dialogText = undefined;
    state.generalError.error = undefined;
    state.generalError.active = true;
  },
  hideGeneralError(state: IRootState): void {
    state.generalError.isBlockedError = false;
    state.generalError.dialogTitle = undefined;
    state.generalError.dialogText = undefined;
    state.generalError.error = undefined;
    state.generalError.active = false;
  },
  showGeneralInfo(state: IRootState, data?: { dialogTitle?: string; dialogText?: string }): void {
    state.generalInfo.dialogTitle = data?.dialogTitle ?? undefined;
    state.generalInfo.dialogText = data?.dialogText ?? undefined;
    state.generalInfo.active = true;
  },
  hideGeneralInfo(state: IRootState): void {
    state.generalInfo.dialogTitle = undefined;
    state.generalInfo.dialogText = undefined;
    state.generalInfo.active = false;
  },
};

export default mutations;
